import {filterArrayUndefined, uniqueArray} from '@coolcolduk/util';

/**
 * Extract parent category IDs from topic IDs
 * @param topicIds - Array of topic IDs in format "category|topic"
 * @returns Array of parent category IDs (just category names)
 */
export default function extractParentTopicStrings(topicStrings: string[]): string[] {
  // Extract categories from category|topic format
  const categoryIds = topicStrings.map((topicString) => topicString.split('|')[0]);

  return uniqueArray(filterArrayUndefined(categoryIds));
}
